import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DiagnosticContext } from '../../helpers/functions';
import { AiFillStar } from 'react-icons/ai';
import { FaUser } from 'react-icons/fa';
import Tooltip from '../tooltip';
import { ExclamationCircleIcon, CogIcon } from '@heroicons/react/24/outline';
import { useMediaQuery } from 'react-responsive';
import Modal from '../Modal';

export const DiagnosticRecomendationDetails = ({ res, tooltip }) => {
  const [detailRecomendations, setDetailRecomendations] = useState(false);
  const { state } = useContext(DiagnosticContext);
  const location = useLocation();
  const isLg = useMediaQuery({ query: `(min-width: 1024px)` });

  const [openTipModel, setOpenTipModel] = useState(false);
  const [openTechnicalModel, setOpenTechnicalModel] = useState(false);

  return (
    <>
      <div className="flex flex-col justify-between border-gray-400">
        <div className="flex flex-col">
          <div className={`${location.pathname === '/diagnostics-recomendations' ? 'flex items-center' : 'hidden'}`}>
            <div className="flex-1 flex">
              <button onClick={() => setDetailRecomendations(!detailRecomendations)}>
                {detailRecomendations ? (
                  <kbd className="arrow-icon ">
                    <svg className="w-4 h-4" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                      <path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z" />
                    </svg>
                  </kbd>
                ) : (
                  <kbd className="arrow-icon">
                    <svg className="w-4 h-4" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                      <path d="M118.6 105.4l128 127.1C252.9 239.6 256 247.8 256 255.1s-3.125 16.38-9.375 22.63l-128 127.1c-9.156 9.156-22.91 11.9-34.88 6.943S64 396.9 64 383.1V128c0-12.94 7.781-24.62 19.75-29.58S109.5 96.23 118.6 105.4z" />
                    </svg>
                  </kbd>
                )}
              </button>
              <p className="text-sm p-1 text-mainBlue font-bold">
                {res.name} ({res.shortName})
              </p>
            </div>
            <div className="flex gap-1">
              {tooltip && isLg && (
                <Tooltip text={tooltip} contentClassName="sm:max-w-[50%]">
                  <ExclamationCircleIcon className="shrink-0 w-8 h-8 m-1 text-red-600" />
                </Tooltip>
              )}
              {!isLg && tooltip && <ExclamationCircleIcon className="shrink-0 w-8 h-8 m-1 text-red-600" onClick={() => setOpenTipModel(true)} />}
              
              {/* Technical Details Icon */}
              {isLg && (
                <Tooltip text="Technische Details anzeigen" contentClassName="sm:max-w-[50%]">
                  <CogIcon className="shrink-0 w-8 h-8 m-1 text-blue-600 cursor-pointer hover:text-blue-800" onClick={() => setOpenTechnicalModel(true)} />
                </Tooltip>
              )}
              {!isLg && <CogIcon className="shrink-0 w-8 h-8 m-1 text-blue-600 cursor-pointer hover:text-blue-800" onClick={() => setOpenTechnicalModel(true)} />}
            </div>
          </div>
          {state.germanSecondaryLanguage && res.dazFairness === 1 && (
            <p className="text-sm text-red-500 italic ml-4 font-semibold">Testfairness für Kinder mit Deutsch als Zweitsprache ist gegeben.</p>
          )}
          {state.germanSecondaryLanguage && res.dazFairness === 0 && (
            <p className="text-sm text-red-500 italic ml-4 font-semibold">
              Testfairness für Kinder mit Deutsch als Zweitsprache ist nicht gegeben.
            </p>
          )}
          {state.germanSecondaryLanguage && res.dazFairness === 99 && (
            <p className="text-sm text-red-500 italic ml-4 font-semibold">
              Testfairness für Kinder mit Deutsch als Zweitsprache wurde nicht überprüft.
            </p>
          )}
          <p className="text-sm pb-2 pt-1 px-2">
            {res?.author}, {res?.year}, {res?.publisher}, {res?.type},
            {res?.processingTimeSingle && <> Bearbeitungszeit Einzeltestung: {res?.processingTimeSingle} Min,</>}
            {res?.processingTimeGroup && <> Bearbeitungszeit Gruppentestung: {res?.processingTimeGroup} Min,</>}
            {/*{Overview && `Normierungsjahr: ${res.standardizationYear}`},*/} Testdurchführung: {res.execution}
          </p>
          {detailRecomendations && (
            <div className="flex flex-col">
              <p className={`${location.pathname === '/diagnostics-recomendations' ? 'flex text-sm p-2' : 'hidden'}`}>{res.description}</p>
            </div>
          )}
        </div>
        {location.pathname === '/diagnostics-overview' && (
          <div className="grid grid-rows-6 grid-cols-2 md:grid-rows-3 md:grid-cols-4 text-xs text-center border-gray-400">
            <div className="space-y-1 row-start-1 col-start-1 border-t border-r border-inherit">
              <p className="py-2">Kompetenzstufen</p>
            </div>
            <div className="grid grid-cols-4 place-items-center row-start-2 col-start-1 border-r border-inherit">
              <div className="">1</div>
              <div className="">2</div>
              <div className="">3</div>
              <div className="">4</div>
            </div>
            <div className="grid grid-cols-4 place-items-center row-start-3 col-start-1 border-r border-inherit">
              {[...Array(4).keys()].map((el) => {
                return (
                  <div>
                    {res.competenceLevels.includes(el + 1) ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4 text-green-500"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4 "
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="row-start-1 col-start-2 row-span-2 border-t md:border-r border-inherit">
              <div className="flex items-center justify-center gap-x-2">
                <p className="py-2">Stichprobengröße</p>
              </div>
            </div>
            <div className="flex items-center row-start-3 col-start-2 md:border-r border-inherit">
              <div className="inline-grid grid-cols-4 gap-3 mx-auto">
                <FaUser className={res.sampleSize >= 1 ? '' : 'opacity-25'} />
                <FaUser className={res.sampleSize >= 2 ? '' : 'opacity-25'} />
                <FaUser className={res.sampleSize >= 3 ? '' : 'opacity-25'} />
                <FaUser className={res.sampleSize === 4 ? '' : 'opacity-25'} />
              </div>
            </div>

            <div className="space-y-1 row-start-4 md:row-start-1 col-start-1 md:col-start-3 row-span-2 border-t border-r border-inherit">
              <p className="py-2">Normierungsjahr</p>
            </div>
            <div className="flex items-center justify-center row-start-6 md:row-start-3 col-start-1 md:col-start-3 border-r border-inherit">
              {res.standardizationYear}
            </div>

            <div className="space-y-1 row-start-4 md:row-start-1 col-start-2 md:col-start-4 row-span-2 border-t border-inherit">
              <div className="flex items-center justify-center gap-x-2">
                <p className="py-2">Güte</p>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3 place-self-center row-start-6 md:row-start-3 col-start-2 md:col-start-4">
              <RatingStars quality={res.quality} />
            </div>
          </div>
        )}
      </div>
      {tooltip && (
        <Modal open={openTipModel} setOpen={setOpenTipModel} bodyClass="px-6 sm:!px-0 sm:!max-w-sm sm:!mx-auto">
          <div className="px-4 py-6 sm:px-6">
            <h3 className="text-base font-semibold leading-7 text-gray-900">Hinweis</h3>
            <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">{tooltip}</p>
          </div>
        </Modal>
      )}
      
      {/* Technical Details Modal */}
      <Modal open={openTechnicalModel} setOpen={setOpenTechnicalModel} bodyClass="px-6 sm:!px-0 sm:!max-w-4xl sm:!mx-auto">
        <div className="px-4 py-6 sm:px-6">
          <h3 className="text-base font-semibold leading-7 text-gray-900">🔧 Technische Details: {res.name}</h3>
          <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">Detaillierte technische Eigenschaften und Bewertungskriterien</p>
        </div>
        <div className="border-t border-gray-100">
          <dl className="divide-y divide-gray-100">
            
            {/* Test Properties */}
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-900">Test-Eigenschaften</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                <div className="font-mono text-xs space-y-1">
                  <div><strong>ID:</strong> {res.id}</div>
                  <div><strong>Kurz-Name:</strong> {res.shortName}</div>
                  <div><strong>Test-Typ:</strong> {res.type}</div>
                  <div><strong>Autor:</strong> {res.author}</div>
                  <div><strong>Jahr:</strong> {res.year}</div>
                  <div><strong>Verlag:</strong> {res.publisher}</div>
                  <div><strong>Durchführung:</strong> {res.execution}</div>
                </div>
              </dd>
            </div>

            {/* Competence Levels */}
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-900">Kompetenzstufen</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                <div className="font-mono text-sm">
                  <div>Abgedeckte KS: [{res.competenceLevels.join(', ')}]</div>
                  <div className="text-xs text-gray-500 mt-1">
                    {res.competenceLevels.length} von 4 Kompetenzstufen abgedeckt
                  </div>
                </div>
              </dd>
            </div>

            {/* Processing Times */}
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-900">Bearbeitungszeiten</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                <div className="font-mono text-sm space-y-1">
                  {res.processingTimeSingle && (
                    <div><strong>Einzeltestung:</strong> {res.processingTimeSingle} Min</div>
                  )}
                  {res.processingTimeGroup && (
                    <div><strong>Gruppentestung:</strong> {res.processingTimeGroup} Min</div>
                  )}
                  {!res.processingTimeSingle && !res.processingTimeGroup && (
                    <div className="text-gray-500">Keine Angaben verfügbar</div>
                  )}
                </div>
              </dd>
            </div>

            {/* Quality Assessment */}
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-900">Qualitätsbewertung</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                <div className="font-mono text-sm space-y-2">
                  <div><strong>Gesamtqualität:</strong> {res.quality}/3 Sterne</div>
                  
                  {res.testItem && (
                    <div className="border border-gray-200 p-3 rounded">
                      <div className="font-semibold mb-2">Detaillierte Gütekriterien:</div>
                      <div className="space-y-1 text-xs">
                        <div><strong>Theoretische Grundlage:</strong> {(res.testItem['CC'] || 0) + 1}/3</div>
                        <div><strong>Objektivität:</strong> {(res.testItem['CD'] || 0) + 1}/3</div>
                        <div><strong>Reliabilität:</strong> {(res.testItem['CE'] || 0) + 1}/3</div>
                        <div><strong>Validität:</strong> {(res.testItem['CF'] || 0) + 1}/3</div>
                        <div><strong>Interpretationseindeutigkeit:</strong> {(res.testItem['CG'] || 0) + 1}/3</div>
                      </div>
                    </div>
                  )}
                </div>
              </dd>
            </div>

            {/* Sample Size and Standardization */}
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-900">Normierung</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                <div className="font-mono text-sm space-y-1">
                  <div><strong>Stichprobengröße:</strong> {res.sampleSize}/4 (Kategorie)</div>
                  <div><strong>Normierungsjahr:</strong> {res.standardizationYear}</div>
                  {res.testItem && res.testItem['CA'] && (
                    <div className="text-xs text-gray-600 mt-2">
                      Stichproben-Code: {res.testItem['CA']}
                    </div>
                  )}
                </div>
              </dd>
            </div>

            {/* DAZ Fairness */}
            {state.germanSecondaryLanguage && (
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-900">DaZ-Fairness</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  <div className="font-mono text-sm">
                    <div><strong>Wert:</strong> {res.dazFairness}</div>
                    <div className="text-xs text-gray-500 mt-1">
                      {res.dazFairness === 1 && "✅ Testfairness ist gegeben"}
                      {res.dazFairness === 0 && "❌ Testfairness ist nicht gegeben"}
                      {res.dazFairness === 99 && "❓ Testfairness wurde nicht überprüft"}
                    </div>
                  </div>
                </dd>
              </div>
            )}

            {/* Category Reliability */}
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-900">Kategorie-Reliabilität</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                <div className="font-mono text-sm space-y-1">
                  <div><strong>Reliable Kategorien:</strong> {res.categoryReliableCount}</div>
                  {res.testItem && (
                    <div className="text-xs text-gray-600">
                      Rohwert: {res.testItem['X'] || 'N/A'}
                    </div>
                  )}
                </div>
              </dd>
            </div>

            {/* Raw Test Item Data (for debugging) */}
            {res.testItem && (
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-900">Rohdaten (Debug)</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  <details>
                    <summary className="cursor-pointer text-blue-600 hover:text-blue-800">
                      Vollständige Testdaten anzeigen
                    </summary>
                    <div className="font-mono text-xs bg-gray-100 p-3 rounded mt-2 max-h-64 overflow-y-auto">
                      <pre>{JSON.stringify(res.testItem, null, 2)}</pre>
                    </div>
                  </details>
                </dd>
              </div>
            )}
            
          </dl>
        </div>
      </Modal>
    </>
  );
};

function RatingStars({ quality }) {
  return (
    <>
      <AiFillStar color={quality >= 1 ? 'ffc107' : null} className={quality >= 1 ? null : 'opacity-25'} />
      <AiFillStar color={quality >= 2 ? 'ffc107' : null} className={quality >= 2 ? null : 'opacity-25'} />
      <AiFillStar color={quality === 3 ? 'ffc107' : null} className={quality === 3 ? null : 'opacity-25'} />
    </>
  );
}
